import React from 'react';
import { noop } from 'lodash';
import GenericSimpleBar from 'simplebar-react';

const SimpleBar = ({ children, ...props }) => {
  const [scrollTop, setScrollTop] = React.useState(0);

  const ref = React.useRef<any>(null);

  const context = {
    getSimpleBar: () => ref.current,
    recalculate: () => ref.current && ref.current.recalculate(),
    scrollTo: (x) => (ref.current.contentWrapperEl.scrollTop = x),
    scrollTop,
  };

  function updatePosition(event) {
    setScrollTop(event.target.scrollTop);
  }

  React.useEffect(() => {
    if (ref.current) {
      ref.current.contentWrapperEl.addEventListener('scroll', updatePosition);
    }

    return () => {
      if (ref.current) {
        ref.current.contentWrapperEl.removeEventListener(
          'scroll',
          updatePosition,
        );
      }
    };
  }, [ref]);

  return (
    <SimpleBarContext.Provider value={context}>
      <GenericSimpleBar {...props} ref={ref}>
        {children}
      </GenericSimpleBar>
    </SimpleBarContext.Provider>
  );
};

export const SimpleBarContext = React.createContext({
  getSimpleBar: noop as any,
  recalculate: noop as any,
  scrollTo: noop as any,
  scrollTop: 0,
});

export default SimpleBar;
